export default __webpack_public_path__ + "static/media/KC.789e8068.png";